/*
 * V_MJA_PDP_40 | Comparison table on PDP - Var B only
 *
 * Var A and Var C are pure Liquid + CSS and need no JavaScript. Var B adds the
 * "Why MJ Arsenal?" infographic to the product media gallery, which cannot be
 * done in Liquid: Swiper counts its slides when it initialises, so a
 * server-rendered slide would leave Control with an extra empty frame. This
 * adds it at runtime, for Var B only, at the position the design places it.
 *
 * The image URLs come from Liquid via data-* attributes on [data-c-pdp40-media]
 * (theme setting first, exported asset as the fallback) - nothing is hardcoded.
 */
(function () {
  'use strict';

  var VAR_B_CLASS = 'c-V_MJA_PDP_40-varB';
  var CONFIG_SELECTOR = '[data-c-pdp40-media]';
  var MAX_WAIT_MS = 15000;

  var SLIDE_ID = 'c-pdp40-infographic';

  function makeImage(src, alt, className) {
    var img = document.createElement('img');
    img.className = className;
    img.src = src;
    img.alt = alt;
    img.loading = 'lazy';
    return img;
  }

  /* ---------------------------------------------------------------- */
  /* Gallery A - the theme's Swiper gallery                            */
  /* ---------------------------------------------------------------- */

  function injectIntoSwiper(slider, src, thumbSrc, alt, position) {
    var swiper = slider.swiper;

    var slide = document.createElement('div');
    slide.className = 'swiper-slide c-pdp40-slide';
    slide.setAttribute('data-media-type', 'image');

    var holder = document.createElement('div');
    holder.className = '#product-gallery-item';
    holder.appendChild(makeImage(src, alt, 'c-pdp40-slide__img'));
    slide.appendChild(holder);

    /*
     * Same position as the Magic360 gallery gets. Appending instead would bury
     * the infographic at the end of the strip - on a product with fourteen
     * photos it lands fourteenth, off-screen, and Var B shoppers never see it.
     */
    var index = Math.max(0, Math.min(position, swiper.slides.length));

    if (typeof swiper.addSlide === 'function') {
      swiper.addSlide(index, slide);
    } else {
      swiper.appendSlide(slide);
      index = swiper.slides.length - 1;
    }

    var thumbs = document.querySelector('slideshow-thumbnails');
    var items = thumbs && thumbs.$items;

    if (items && items.length) {
      var shifted = index < items.length;

      var thumb = document.createElement('div');
      thumb.className = '#slideshow-thumbnails-item c-pdp40-thumb';
      thumb.setAttribute('data-item', String(index));
      thumb.appendChild(makeImage(thumbSrc, '', 'c-pdp40-thumb__img'));

      var reference = items[index] || items[items.length - 1];
      if (reference && reference.parentNode) {
        if (items[index]) {
          reference.parentNode.insertBefore(thumb, reference);
        } else {
          reference.parentNode.appendChild(thumb);
        }
      }

      /*
       * The thumbnails component snapshots its items into $items at init and
       * _setActive() indexes straight into that array, so the thumbnail has to
       * go in at the same position as its slide. Pushing it on the end instead
       * would leave every highlight past the infographic one thumbnail out, and
       * reading past the end throws, which kills highlighting for the visit.
       */
      items.splice(index, 0, thumb);

      /*
       * Each thumbnail's click is also bound at init, capturing the index it
       * had THEN - () => slideTo(i). Inserting ahead of them leaves every later
       * thumbnail opening the slide before the one it shows. Those handlers
       * cannot be unbound from here, so catch the click on the way down,
       * navigate by the thumbnail's live position and stop the stale handler
       * from running. Scoped to [data-item], so the strip's prev/next arrows -
       * handled separately on this same element - are untouched.
       */
      if (shifted && thumbs && !thumbs.dataset.cPdp40Rebound) {
        thumbs.dataset.cPdp40Rebound = 'true';
        thumbs.addEventListener('click', function (event) {
          var target = event.target;
          var item = target && target.closest ? target.closest('[data-item]') : null;
          if (!item || !thumbs.contains(item)) return;

          var live = items.indexOf(item);
          if (live < 0) return;

          event.stopImmediatePropagation();
          if (typeof slider.slideTo === 'function') slider.slideTo(live);
        }, true);
      }
    }

    swiper.update();
    return true;
  }

  /* ---------------------------------------------------------------- */
  /* Gallery B - the Magic360 app gallery                              */
  /* ---------------------------------------------------------------- */

  /*
   * Most PDPs on this store render the Magic360 spin viewer instead of the
   * theme's Swiper gallery, and leave the Swiper one inside a display:none
   * fallback. Magic360 is a different component entirely: a jQuery stage of
   * .MagicToolboxSlide elements keyed by data-slide-id, plus a Flickity
   * thumbnail strip. It needs its own path rather than the Swiper one.
   */
  function injectIntoMagic360(container, src, thumbSrc, alt, position) {
    var stage = container.querySelector('.MagicToolboxSlides');
    var strip = container.querySelector('.MagicToolboxSelectorsContainer');
    if (!stage || !strip) return false;

    var slide = document.createElement('div');
    slide.className = 'MagicToolboxSlide c-pdp40-slide';
    slide.setAttribute('data-slide-id', SLIDE_ID);
    slide.appendChild(makeImage(src, alt, 'c-pdp40-slide__img'));
    stage.appendChild(slide);

    var thumb = document.createElement('a');
    thumb.href = '#';
    thumb.className = 'js-no-transition c-pdp40-thumb';
    thumb.setAttribute('data-slide-id', SLIDE_ID);
    thumb.appendChild(makeImage(thumbSrc, '', 'c-pdp40-thumb__img'));

    /*
     * The strip is a Flickity carousel showing roughly five cells at a time,
     * with its prev/next buttons switched off - so anything appended at the end
     * sits off-screen and is only reachable by dragging. Most shoppers never
     * would, which makes a tail position effectively invisible. Insert it near
     * the front instead, where the design places it.
     *
     * Flickity.data() reaches the instance the app kept in a local variable;
     * insert() registers and measures the cell, which a bare DOM insert would
     * not. Position comes from the theme settings, not a magic number.
     */
    var flickity = window.Flickity && window.Flickity.data ? window.Flickity.data(strip) : null;
    if (flickity && typeof flickity.insert === 'function') {
      flickity.insert(thumb, position);
    } else {
      var siblings = strip.querySelectorAll('a[data-slide-id]');
      if (siblings.length > position) {
        siblings[position].parentNode.insertBefore(thumb, siblings[position]);
      } else {
        strip.appendChild(thumb);
      }
    }

    /*
     * The app binds its selector handler on DOM ready to the elements that
     * existed then, so this thumbnail needs its own. It mirrors exactly what
     * the app's handler does.
     */
    function activate(event) {
      if (event && event.preventDefault) event.preventDefault();

      /*
       * The slide starts hidden, so its lazy image never enters the viewport
       * and the browser never fetches it - the shopper would open the
       * infographic and find an empty frame. Switching to eager on the first
       * open starts the fetch exactly when it is wanted, without making every
       * Var B page load carry the artwork up front.
       */
      var full = slide.querySelector('img');
      if (full && full.loading === 'lazy') full.loading = 'eager';

      var slides = container.querySelectorAll('.MagicToolboxSlide');
      for (var i = 0; i < slides.length; i++) slides[i].classList.remove('active-magic-slide');
      slide.classList.add('active-magic-slide');

      var selectors = strip.querySelectorAll('a');
      for (var j = 0; j < selectors.length; j++) selectors[j].classList.remove('active-magic-selector');
      thumb.classList.add('active-magic-selector');
    }

    /*
     * Bind through jQuery, not addEventListener, because that is the only way
     * the prev/next arrows can reach this thumbnail. The arrows navigate by
     * calling jQuery's .trigger('click') on the neighbouring selector, and
     * jQuery deliberately does not dispatch a native click on an anchor - its
     * event.special.click._default hook returns true for <a>, which suppresses
     * the native elem.click() call. A native listener therefore only ever ran
     * on a real mouse click, so this thumbnail was a dead end for the arrows:
     * pressing back from the photo after it did nothing at all, leaving the
     * infographic, the first photo and the 360 view unreachable.
     *
     * The native path stays as the fallback for the case where the app's own
     * jQuery has not loaded yet - there the app's DOM-ready binding picks this
     * thumbnail up by its data-slide-id anyway, because it is already in the
     * strip by then.
     */
    if (window.jQuery) {
      window.jQuery(thumb).on('click', activate);
    } else {
      thumb.addEventListener('click', activate);
    }

    return true;
  }

  /* ---------------------------------------------------------------- */

  function injectSlide() {
    if (!document.body || !document.body.classList.contains(VAR_B_CLASS)) return false;

    var config = document.querySelector(CONFIG_SELECTOR);
    if (!config) return true;                       // not an eligible product - stop waiting
    if (config.dataset.cPdp40MediaDone === 'true') return true;

    var src = config.getAttribute('data-c-pdp40-src');
    if (!src) return true;

    var alt = config.getAttribute('data-c-pdp40-alt') || '';
    var thumbSrc = config.getAttribute('data-c-pdp40-thumb') || src;

    // Whichever gallery this product actually renders is the one to add to.
    var position = parseInt(config.getAttribute('data-c-pdp40-position'), 10);
    if (isNaN(position) || position < 0) position = 2;

    var magic360 = document.querySelector('.MagicToolboxContainer');
    if (magic360 && magic360.getBoundingClientRect().width > 0) {
      if (!injectIntoMagic360(magic360, src, thumbSrc, alt, position)) return false;
      config.dataset.cPdp40MediaDone = 'true';
      return true;
    }

    var slider = document.querySelector('slide-show');
    if (slider && slider.swiper && slider.swiper.slides &&
        slider.getBoundingClientRect().width > 0) {
      if (!injectIntoSwiper(slider, src, thumbSrc, alt, position)) return false;
      config.dataset.cPdp40MediaDone = 'true';
      return true;
    }

    return false;   // neither gallery is up yet - keep waiting
  }

  /*
   * Intelligems can apply the body class after DOMContentLoaded and after
   * ig:ready, and the gallery initialises on its own clock, so neither event is
   * a reliable single trigger. Watch the body class and poll briefly for the
   * gallery, then stop - the pattern the working tests on this theme use.
   */
  function start() {
    if (injectSlide()) return;

    var startedAt = Date.now();
    var timer = window.setInterval(function () {
      if (injectSlide() || Date.now() - startedAt > MAX_WAIT_MS) {
        window.clearInterval(timer);
      }
    }, 200);
  }

  if (document.body) {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start);
  }

  if (typeof MutationObserver === 'function') {
    var watcher = new MutationObserver(function () {
      if (document.body.classList.contains(VAR_B_CLASS)) {
        watcher.disconnect();
        start();
      }
    });
    if (document.body) {
      watcher.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }
  }

  window.addEventListener('ig:ready', function () {
    window.setTimeout(start, 0);
  });
})();
